import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';

import {activeUser} from './userReducer';
import {appDisplay} from "../../containers/tenant/reducers/appDisplayReducer";
import {errors} from './errorsReducer';
import {flowKeys, overlays} from "./displayReducer";
import {modals} from './displayReducer';
import {isLoading, showAddListingModal, showAddPropertyModal, showInviteTenantModal} from './displayReducer';
import {listings} from '../../containers/listings/reducers/listingsReducer';
import {navbar} from '../../containers/navigation/reducers/navbar';
import {owner} from '../../containers/owner/reducers/ownerReducer';
import {tenant} from '../../containers/tenant/reducers/tenantReducer';
import {guarantor} from "../../containers/guarantor/reducers/guarantorReducer";
import {reference} from '../../containers/reference/reducers/referenceReducer';
import initialState from '../../initialState.json';
import C from '../../constants';
import {unclaimed_properties} from "../../containers/unclaimed/reducers/unclaimedReducer";
import {credit} from "./creditReducer";

const appReducer = combineReducers({
    activeUser,
    credit,
    display: combineReducers({
        navbar,
        isLoading,
        showAddPropertyModal,
        showAddListingModal,
        showInviteTenantModal,
        appDisplay,
        flowKeys,
        modals,
        overlays,
    }),
    errors,
    form: formReducer,
    listings,
    owner,
    tenant,
    guarantor,
    reference,
    unclaimed_properties: unclaimed_properties
});

export default (state, action) => {
    if (action.type === C.CLEAR_USER) {
        // clear everything and reset store
        state = initialState;
    }

    return appReducer(state, action);
}



// WEBPACK FOOTER //
// ./src/store/reducers/index.js